<template>
    <div>
        <b-row>
            <b-col cols="12">
                <h4>Import any .CSV, .XLS or .XLSX file type</h4>
                <b-link href="javascript:void(0)" @click="downloadImportFile">Download sample file</b-link>
            </b-col>
            <b-col cols="12">
                <vue-dropzone id="dropzone" 
                    :options="dropzoneOptions" 
                    :useCustomSlot=true
										v-on:vdropzone-file-added="addFile"
                    v-on:vdropzone-sending="sendingEvent"
                    v-on:vdropzone-success="importSuccess"
                    v-on:vdropzone-error="importError"
                >
                    <b-icon icon="cloud-arrow-up-fill" font-scale="4"></b-icon>
                    <p class="mb-0">Upload files or Drop files here</p>
                </vue-dropzone>
            </b-col>
						<b-col cols="12" class="my-2">
								<el-checkbox v-model="skip_assign">Allow Empty Assign</el-checkbox>
            </b-col>
            <b-col cols="12">
                <small class="text-break">*Leads are distinguished by their name and contact no.</small>
            </b-col>
        </b-row>

        <!-- Modal Overwrite and Update Contacts -->
        <modal :show.sync="modals.files_uploaded" modalClasses="large-sized-modal" footerClasses="d-flex justify-content-center">
            <div slot="header" class="d-flex align-items-center">
                <b-icon icon="chevron-left" class="font-weight-bold mr-2" @click="toggleModal" style="cursor: pointer;"></b-icon>
                <h6 class="modal-title">Import Confirmation</h6>
            </div>
            <b-row class="d-flex justify-content-center">
                <b-col cols="12">
                  <el-collapse accordion class="border-0">
										<el-collapse-item name="1" class="my-3" style="min-width: 800px !important;">
											<div slot="title" class="collapse-header px-3">
												<h3 class="mb-0">Total {{ checkData.created }} New <br/>
													<small class="text-success">A list of new leads and not exist on system</small>
												</h3>
                                    </div>
											<ImportSummaryContent :tableData="tableDataNew" :import_status="'NEW'"/>
										</el-collapse-item>
										<el-collapse-item name="2" class="my-3" style="min-width: 800px !important;">
											<div slot="title" class="collapse-header px-3">
												<h3 class="mb-0">Total {{ checkData.updated }} Existing No Assigned <br/>
													<small class="text-warning">A list of existing leads that have never been assigned to an agent or user. It will overide existing data</small>
												</h3>
                                    </div>
											<ImportSummaryContent :tableData="tableDataUpdate" :import_status="'UPDATE'" />
										</el-collapse-item>
										<el-collapse-item name="3" class="my-3" style="min-width: 800px !important;">
											<div slot="title" class="collapse-header px-3">
												<h3 class="mb-0">Total {{ checkData.duplicate }} Duplicate <br/>
													<small class="text-danger">A list of existing leads and already assigned to agents or users. System will skip importing this lead</small>
												</h3>
                                </div>
											<ImportSummaryContent :tableData="tableDataDuplicate" :import_status="'DUPLICATE'"/>
										</el-collapse-item>
									</el-collapse>
                </b-col>
            </b-row>
            <b-row slot="footer">
                <b-button variant="danger" @click="finishImport">Cancel</b-button>
                <b-button variant="primary" @click="proceedImport">Import</b-button>
            </b-row>
        </modal>
    </div>
</template>

<script>
    import { Button, Checkbox, Table, TableColumn, Collapse, CollapseItem } from 'element-ui'
    import vue2Dropzone, { methods } from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import {
        notifyFunctionMixin,
        axios,
        services,
        getHeader,
    } from '@/assets/js/httpImports.js'
    import helperFunctionMixin from '@/assets/js/helperFunctionMixin'
    import { useAuthStore } from '@/stores/authStore'
    import { mapState } from 'pinia'
    import {CORPORATE_ID_FOLLOW_SAS_LEAD} from '@/assets/js/corporate.js'
		import ImportSummaryContent from '@/views/Leads/LeadsListingComponents/ImportSummaryContent'

    export default {
        name: 'import-files-modal-content',
        props: ['uploadURL','checkURL'],
        components: {
						ImportSummaryContent,
            vueDropzone: vue2Dropzone,
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
						[Collapse.name]: Collapse,
						[CollapseItem.name]: CollapseItem
        },
        mixins: [notifyFunctionMixin, helperFunctionMixin],
        data() {
            return {
                CORPORATE_ID_FOLLOW_SAS_LEAD:CORPORATE_ID_FOLLOW_SAS_LEAD,
                is_override: false,
							skip_assign: false,
							fileData: null,
							checkData: {
								created:0,
								updated:0,
								duplicate:0,
								summary:[],
							},
                dropzoneOptions: {	
									url: services.lead + this.checkURL,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    paramName: 'import_lead',
                    headers: { ...getHeader(), "Cache-Control": "" },
                },
                overwrite_update: false,
                modals: {
                    files_uploaded: false,
							}
            }
        },
        watch: {
            // overwrite_update(toggle) {
            //     if (toggle) {
            //         this.modals.files_uploaded = !this.modals.files_uploaded
            //     }
            // }
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user']),
						tableDataUpdate(){
							if(_gHlp.isEmpty(this.checkData) || _gHlp.isEmpty(this.checkData.summary)) return [];
							return this.checkData.summary.filter((data)=>{
								return data.import_status == "UPDATE";
							})
						},
						tableDataDuplicate(){
							if(_gHlp.isEmpty(this.checkData) || _gHlp.isEmpty(this.checkData.summary)) return [];
							return this.checkData.summary.filter((data)=>{
								return data.import_status == "DUPLICATE";
							})
						},
						tableDataNew(){
							if(_gHlp.isEmpty(this.checkData) || _gHlp.isEmpty(this.checkData.summary)) return [];
							return this.checkData.summary.filter((data)=>{
								return data.import_status == "NEW";
							})
						}
        },
        methods: {
						addFile(file){
							this.fileData = file;
						},
            sendingEvent(file, xhr, formData) {
              formData.append("is_override", this.is_override);
							formData.append("skip_assign", this.skip_assign);
            },
            importSuccess(file, res){
                setTimeout(() => {
										this.checkData = res.data;
										this.toggleModal();
                }, 1000);
            },
            importError(file, message, xhr){
                file.previewElement.querySelectorAll('.dz-error-message span')[0].textContent = message.message;
                this.errorFunction(xhr, '<b>Import Error: </b>' + message.message)
            },
            downloadImportFile(){
                let url = 'lead/import'
                axios.get(services.lead + url,{
                    headers: getHeader(),
                    responseType: 'blob'
                })
                .then(response => {
                    this.createDownloadFileLink(response.data, 'import_lead_v1.xlsx')
                })
                .catch(e => {
                    this.errorFunction(e)
                });
            },
            toggleModal() {
                this.modals.files_uploaded = !this.modals.files_uploaded
            },
						proceedImport(){
							let isDirty = (this.tableDataUpdate.length > 0) || (this.tableDataDuplicate.length > 0);
							if(!isDirty || confirm("Your import data has detected have duplicate or existing leads, are you sure override or duplicate for the existing leads ?")){
								const formData = new FormData();
								const reqHeader = getHeader();
								reqHeader['Content-Type'] = 'multipart/form-data';
								
								formData.append("is_override", (this.checkData.duplicate > 0 ? true:false));
								formData.append("skip_assign", this.skip_assign);
								formData.append("import_lead", (this.fileData));
								
								axios.post(services.lead + this.uploadURL, formData, { headers: reqHeader })
								.then((res) => {
									if(!_gHlp.isEmpty(res.data) && !_gHlp.isEmpty(res.data.data)){
										let x = res.data.data; 
										_gNotif.notifySuccess('<b>Lead :</b> Successfully Imported. <br> Created: '+x.created+' <br> Updated: '+x.updated+' <br> Skip Importing: '+x.duplicate)
									}
									this.finishImport();
								})
								.catch(e => {
									_gNotif.errorFunction(e)
								})
							}
						},
						finishImport(){
							this.fileData = null;
							this.checkData = {
								created:0,
								updated:0,
								duplicate:0,
								summary:[],
							};
							this.modals.files_uploaded = false;
							this.$emit('importSuccess');
            }
        }
    }
</script>